import ContactCard from "../../components/contact/ContactCard";
import ContactForm from "../../components/forms/ContactForm";
import Location from "../../components/contact/Location";
import useAppData from "../../hooks/useAppData";

const Contact = () => {
	const { settings, contactPage } = useAppData();
	return (
		<>
			<title>{contactPage.meta_title}</title>
			<meta name="description" content={contactPage.meta_description} />
			<meta name="keywords" content={contactPage.meta_keywords} />

			<main className="bg-white">
				{/* Banner Section */}
				<section className="relative h-70 md:h-75 w-full overflow-hidden">
					<img
						src="/assets/images/banners/contact-us-banner.jpg"
						className="absolute inset-0 w-full h-full object-cover"
						alt="Contact Banner"
					/>
					<div className="absolute inset-0 bg-black/60 flex flex-col items-center justify-center text-white px-4 pt-25">
						<h1 className="text-2xl md:text-4xl font-bold uppercase Ethnocentric tracking-wider text-center">
							Get in touch with us Today
						</h1>
						<p className="mt-4 text-sm md:text-base opacity-90">
							Home &nbsp; • &nbsp; Contact us
						</p>
					</div>
				</section>

				<section className="max-w-7xl mx-auto px-4 py-16 md:py-24">
					<div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
						{/* Info Column */}
						<div className="space-y-12">
							<h2 className="text-2xl md:text-4xl Ethnocentric leading-tight text-gray-900">
								<span className="text-brand-500">Connect</span> with us Today
								and <span className="text-brand-500">we'll Help you</span>
							</h2>

							<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
								<ContactCard
									icon="/assets/icons/phone-call.png"
									title="Phone Number"
									items={settings?.phone_number}
									linkPrefix="tel:"
								/>
								<ContactCard
									icon="/assets/icons/email.png"
									title="Email Address"
									items={settings?.email}
									linkPrefix="mailto:"
								/>
								<ContactCard
									icon="/assets/icons/location.png"
									title="Address"
									description={settings?.office_address || "Not Available"}
									link={settings?.google_maps_link || "#"}
								/>
								<ContactCard
									icon="/assets/icons/calendar.png"
									title="Business Hours"
									description={settings?.business_hours || ""}
								/>
							</div>
						</div>

						{/* Form Column */}
						<div className="bg-gray-50 rounded-3xl p-2 md:p-4 shadow-inner">
							<ContactForm />
						</div>
					</div>
				</section>

				{/* Location Map Section */}
				<section className="bg-gray-500">
					<Location google_map_link={settings?.google_map_link || ""} google_map_embed={settings?.google_map_embed || ""}/>
				</section>
			</main>
		</>
	);
};

export default Contact;
